/**
 * Auto-generated from dark-roast DAOs (com.axiom.db.models.dao).
 * Shared by all Java backends — do not edit manually.
 * Regenerate with: yarn sync-entities
 */

import { Entity } from '@data-client/rest';
export class PracticeAreaEntity extends Entity {
  bullhornId: string | null = null;
  id: string = '';
  name: string | null = null;
  parent: PracticeAreaEntity | null = null;
  parentId: string | null = null;
  type: string | null = null;
  static override key = 'PracticeArea';
  static override get schema() {
    return {
      parent: PracticeAreaEntity,
    };
  }
  static override toJSON() {
    return { name: this.name, schema: {}, key: this.key };
  }
  static override process(input: unknown): unknown {
    if (
      input !== null &&
      typeof input === 'object' &&
      'PracticeArea' in input
    ) {
      const { PracticeArea: wrapped, ...rest } = input as {
        PracticeArea: object;
      } & object;
      return { ...(wrapped as object), ...rest };
    }
    return input;
  }
}